export default __webpack_public_path__ + "static/media/foundationcourse.4a4cbe48.png";